import { render, staticRenderFns } from "./Importador.vue?vue&type=template&id=696a16d4"
import script from "./Importador.vue?vue&type=script&lang=js"
export * from "./Importador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports